import type { ComponentType, ReactNode } from "react";
import { cn } from "../lib/cn";

export type EmptyStateProps = {
  /** A Phosphor icon component. */
  icon?: ComponentType<{ size?: number; className?: string; weight?: "thin" | "light" | "regular" | "bold" | "fill" | "duotone" }>;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
};

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn("flex flex-col items-start gap-3 py-12", className)}>
      {Icon && <Icon size={20} className="text-ink-3" />}
      <h2 className="font-display text-xl text-ink">{title}</h2>
      {description && <p className="max-w-prose text-sm text-ink-2">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
